module.exports = __webpack_public_path__ + "img/lishifabu.e541c09c.png";